import generalDe from '$lib/i18n/locales/de/generalDE.json';
import shopDe from '$lib/i18n/locales/de/shopDE.json';
import accountDe from '$lib/i18n/locales/de/accountDE.json';
import checkoutDe from '$lib/i18n/locales/de/checkoutDE.json';
import errorDe from '$lib/i18n/locales/de/errorDE.json';

export default {
    localeName: 'Deutsch',
    localeIdentifier: 'de-DE',
    general: generalDe,
    shop: shopDe,
    account: accountDe,
    checkout: checkoutDe,
    error: errorDe
};
